import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, User, ArrowRight } from 'lucide-react';
import { imageUrl, formatDate, PATHS } from '../../lib/opinly';

export default function PostCard({ post, featured = false }) {
  const img = imageUrl(post.image?.fileKey);
  return (
    <article data-testid={`post-card-${post.slug}`} className={`card-soft overflow-hidden flex flex-col h-full group ${featured ? 'md:flex-row' : ''}`}>
      <Link to={PATHS.post(post.slug)} className={`block overflow-hidden bg-slate-100 ${featured ? 'md:w-1/2 aspect-[16/10] md:aspect-auto' : 'aspect-[16/10]'}`} aria-label={post.title}>
        {img ? (
          <img src={img} alt={post.image?.alt || post.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]" />
        ) : (
          <div className="h-full w-full flex items-center justify-center text-4xl font-extrabold" style={{ background: 'linear-gradient(135deg, #e6f2f7, #d7ecf4)', color: '#3d94b8' }}>{post.title?.[0]}</div>
        )}
      </Link>
      <div className={`p-6 flex flex-col flex-1 ${featured ? 'md:w-1/2 md:p-8' : ''}`}>
        <div className="flex flex-wrap items-center gap-2 text-xs">
          {post.category && (
            <Link to={PATHS.category(post.category.slug)} className="font-semibold uppercase tracking-wider px-2.5 py-1 rounded-full" style={{ background: '#e6f2f7', color: '#2d7d9a' }}>{post.category.name}</Link>
          )}
          <span className="inline-flex items-center gap-1 text-slate-500"><Calendar className="h-3.5 w-3.5" /> <time dateTime={post.firstPublishedAt}>{formatDate(post.firstPublishedAt)}</time></span>
        </div>
        <h3 className={`mt-3 font-extrabold leading-snug ${featured ? 'text-2xl md:text-3xl' : 'text-lg'}`} style={{ color: '#1a3a5c' }}>
          <Link to={PATHS.post(post.slug)} className="hover:underline decoration-2 underline-offset-4" style={{ textDecorationColor: '#3d94b8' }}>{post.title}</Link>
        </h3>
        {post.description && <p className={`mt-2 text-slate-600 ${featured ? 'text-base' : 'text-sm'} line-clamp-3`}>{post.description}</p>}
        <div className="mt-auto pt-5 flex items-center justify-between gap-3">
          {post.author ? (
            <Link to={PATHS.author(post.author.slug)} className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-slate-900 min-w-0">
              {imageUrl(post.author.fileKey) ? <img src={imageUrl(post.author.fileKey)} alt="" className="h-7 w-7 rounded-full object-cover" /> : <span className="h-7 w-7 rounded-full flex items-center justify-center" style={{ background: '#e6f2f7' }}><User className="h-3.5 w-3.5" style={{ color: '#3d94b8' }} /></span>}
              <span className="truncate">{post.author.name}</span>
            </Link>
          ) : <span />}
          <Link to={PATHS.post(post.slug)} className="text-sm font-semibold inline-flex items-center gap-1 hover:gap-2 transition-all shrink-0" style={{ color: '#2d7d9a' }}>Lesen <ArrowRight className="h-3.5 w-3.5" /></Link>
        </div>
      </div>
    </article>
  );
}

export function PostCardSkeleton() {
  return (
    <div className="card-soft overflow-hidden animate-pulse" aria-hidden="true">
      <div className="aspect-[16/10] bg-slate-100" />
      <div className="p-6 space-y-3"><div className="h-3 w-24 bg-slate-100 rounded" /><div className="h-5 w-3/4 bg-slate-100 rounded" /><div className="h-4 w-full bg-slate-100 rounded" /><div className="h-4 w-2/3 bg-slate-100 rounded" /></div>
    </div>
  );
}
